export const ANSWER_TEMPLATE = Object.freeze({
  LAW_SCHOOL_COUNCIL: "law_school_council",
  MINISTRY_OF_JUSTICE: "ministry_of_justice",
});

export const ANSWER_TEMPLATE_OPTIONS = Object.freeze([
  {
    value: ANSWER_TEMPLATE.LAW_SCHOOL_COUNCIL,
    label: "법전협 양식",
    description: "법학전문대학원협의회 답안지 양식",
  },
  {
    value: ANSWER_TEMPLATE.MINISTRY_OF_JUSTICE,
    label: "법무부 양식",
    description: "실제 변호사시험 CBT의 답안 입력 양식",
  },
]);

export const normalizeAnswerTemplate = (templateType) =>
  ANSWER_TEMPLATE_OPTIONS.some(({ value }) => value === templateType)
    ? templateType
    : ANSWER_TEMPLATE.LAW_SCHOOL_COUNCIL;

export const getAnswerTemplateLabel = (templateType) =>
  ANSWER_TEMPLATE_OPTIONS.find(
    ({ value }) => value === normalizeAnswerTemplate(templateType),
  )?.label || "법전협 양식";
